/* VanillaGoods Food Safety: "What makes people sick" outbreak explorer (sections/vg-food-safety.liquid).
   Live CDC National Outbreak Reporting System (NORS) data from data.cdc.gov (dataset 5xkq-dg7x), foodborne
   outbreaks only, read in the visitor's browser. Two single-series horizontal bar charts (cause, food) plus totals,
   filtered by state, years and measure. Labels from the API are inserted with textContent only. */
(function () {
  'use strict';
  var root = document.querySelector('[data-ob]');
  if (!root) return;

  var API = 'https://data.cdc.gov/resource/5xkq-dg7x.json';
  var TOP = 9;                                   // bars before folding the rest into "Other"
  var MEASURES = {
    outbreaks: { label: 'Outbreaks', one: 'outbreak' },
    ill: { label: 'Illnesses', one: 'illness' },
    hosp: { label: 'Hospitalizations', one: 'hospitalization' },
    deaths: { label: 'Deaths', one: 'death' }
  };

  // CDC etiology names -> plain-language groups
  var CAUSES = [
    ['Norovirus', /norovirus/i],
    ['Salmonella', /salmonella/i],
    ['Clostridium perfringens', /clostridium perfringens/i],
    ['E. coli', /escherichia coli|\be\.?\s?coli\b/i],
    ['Staph (Staphylococcus aureus)', /staphylococcus/i],
    ['Bacillus cereus', /^bacillus/i],
    ['Campylobacter', /campylobacter/i],
    ['Fish & shellfish toxins', /scombroid|histamine|ciguatoxin|tetrodotoxin|shellfish poison/i],
    ['Vibrio', /vibrio/i],
    ['Shigella', /shigella/i],
    ['Listeria', /listeria/i],
    ['Cyclospora', /cyclospora/i],
    ['Hepatitis A', /hepatitis a/i],
    ['Botulism (C. botulinum)', /botulinum/i],
    ['Parasites', /cryptosporidium|giardia|trichinella|toxoplasma/i],
    ['Chemicals & toxins', /chemical|mycotoxin|cleaning|heavy metal|pesticide|plant\/herbal|toxin/i]
  ];
  var FOODS = {
    'Grains-beans': 'Grains & beans', 'Vegetable Row Crops': 'Leafy & row vegetables', 'Root/Underground': 'Root vegetables',
    'Nuts-seeds': 'Nuts & seeds', 'Oils-sugars': 'Oils & sugars', 'Seeded Vegetables': 'Seeded vegetables',
    'Multiple': 'Several foods', 'Other': 'Other foods', 'Other Meat': 'Other meat', 'Other Poultry': 'Other poultry',
    'Other Aquatic Animals': 'Other seafood', 'Mollusks': 'Mollusks (oysters, clams)', 'Crustaceans': 'Crustaceans (shrimp, crab)'
  };

  function causeOf(raw) {
    if (!raw) return 'Unknown cause';
    var seen = {};
    String(raw).split(';').forEach(function (part) {
      part = part.trim();
      if (!part) return;
      var hit = CAUSES.filter(function (c) { return c[1].test(part); })[0];
      seen[hit ? hit[0] : 'Other causes'] = 1;
    });
    var keys = Object.keys(seen);
    return keys.length === 1 ? keys[0] : keys.length ? 'More than one germ' : 'Unknown cause';
  }
  function foodOf(raw) {
    if (!raw || raw === 'N/A') return null;          // no single food identified
    return FOODS[raw] || raw;
  }

  // ------------------------------------------------------------------ data
  function soql(params) {
    return API + '?' + Object.keys(params).map(function (k) { return k + '=' + encodeURIComponent(params[k]); }).join('&');
  }
  var cache = {};
  function get(u) {
    if (!cache[u]) {
      cache[u] = fetch(u).then(function (r) { if (!r.ok) throw new Error('CDC ' + r.status); return r.json(); });
      cache[u].catch(function () { delete cache[u]; });
    }
    return cache[u];
  }
  function where(f) {
    var w = ["primary_mode='Food'", 'year >= ' + (+f.from), 'year <= ' + (+f.to)];
    if (f.state) w.push("state='" + String(f.state).replace(/'/g, "''") + "'");
    return w.join(' AND ');
  }
  var SUMS = 'count(*) as outbreaks, sum(illnesses) as ill, sum(hospitalizations) as hosp, sum(deaths) as deaths';
  function grouped(field, f) {
    return get(soql({ $select: field + ', ' + SUMS, $where: where(f), $group: field, $limit: 5000 }));
  }
  function n(v) { var x = +v; return isFinite(x) ? x : 0; }
  function fold(rows, keyFn) {
    var m = {};
    rows.forEach(function (r) {
      var k = keyFn(r);
      if (k == null) return;
      var o = m[k] || (m[k] = { name: k, outbreaks: 0, ill: 0, hosp: 0, deaths: 0 });
      o.outbreaks += n(r.outbreaks); o.ill += n(r.ill); o.hosp += n(r.hosp); o.deaths += n(r.deaths);
    });
    return Object.keys(m).map(function (k) { return m[k]; });
  }
  function topN(list, measure, pinnedLast) {
    var pinned = list.filter(function (x) { return pinnedLast.indexOf(x.name) !== -1; });
    var rest = list.filter(function (x) { return pinnedLast.indexOf(x.name) === -1; })
      .sort(function (a, b) { return b[measure] - a[measure] || a.name.localeCompare(b.name); });
    var shown = rest.slice(0, TOP), other = rest.slice(TOP);
    if (other.length) {
      var o = { name: 'All other (' + other.length + ')', outbreaks: 0, ill: 0, hosp: 0, deaths: 0, folded: other };
      other.forEach(function (x) { o.outbreaks += x.outbreaks; o.ill += x.ill; o.hosp += x.hosp; o.deaths += x.deaths; });
      shown.push(o);
    }
    pinned.sort(function (a, b) { return pinnedLast.indexOf(a.name) - pinnedLast.indexOf(b.name); });
    pinned.forEach(function (p) { p.pinned = true; shown.push(p); });
    return shown.filter(function (x) { return x.outbreaks > 0; });
  }

  // ------------------------------------------------------------------ rendering
  var fmt = function (v) {   // whole numbers; averages under 10 keep one decimal (e.g. 0.4 outbreaks a year)
    var r = Math.round(v);
    return Math.abs(v) < 10 && Math.abs(v - r) >= 0.05 ? v.toFixed(1) : r.toLocaleString('en-US');
  };
  var tip = root.querySelector('[data-ob-tip]');
  function showTip(row, el) {
    if (!tip) return;
    tip.innerHTML = '';
    var h = document.createElement('p'); h.className = 'ob-tip-h';
    h.textContent = row.name + (row.share != null ? ' (' + pct(row.share, 1) + ' of total)' : ''); tip.appendChild(h);
    Object.keys(MEASURES).forEach(function (k) {
      var p = document.createElement('p'); p.className = 'ob-tip-r' + (k === state.measure ? ' is-on' : '');
      var b = document.createElement('b'); b.textContent = fmt(row[k]);
      p.appendChild(b); p.appendChild(document.createTextNode(' ' + MEASURES[k].label.toLowerCase()));
      tip.appendChild(p);
    });
    if (row.folded) {
      var f = document.createElement('p'); f.className = 'ob-tip-note';
      f.textContent = row.folded.slice(0, 6).map(function (x) { return x.name; }).join(', ') + (row.folded.length > 6 ? ', …' : '');
      tip.appendChild(f);
    }
    var box = root.getBoundingClientRect(), r = el.getBoundingClientRect();
    tip.hidden = false;
    var left = Math.min(Math.max(r.left - box.left + 12, 8), box.width - tip.offsetWidth - 8);
    tip.style.left = left + 'px';
    tip.style.top = (r.bottom - box.top + 6) + 'px';
  }
  function hideTip() { if (tip) tip.hidden = true; }

  // bar colour = share of the chart's total, scaled per chart from the smallest to the largest named share:
  // yellow (smaller) through orange to red (larger). Grouped rows (All other, More than one germ, Unknown cause)
  // keep the muted beige so they don't read as hot spots.
  var HEAT = [[246, 213, 92], [230, 126, 34], [184, 50, 42]];
  function pct(v, total) { var p = v / (total || 1) * 100; return (p > 0 && p < 1 ? '<1' : Math.round(p)) + '%'; }
  function heat(t) {
    t = Math.max(0, Math.min(1, t));
    var i = t < 0.5 ? 0 : 1, u = t < 0.5 ? t * 2 : (t - 0.5) * 2, a = HEAT[i], b = HEAT[i + 1];
    return 'rgb(' + [0, 1, 2].map(function (k) { return Math.round(a[k] + (b[k] - a[k]) * u); }).join(',') + ')';
  }
  function bars(box, rows, measure) {
    box.innerHTML = '';
    var max = rows.reduce(function (m, r) { return Math.max(m, r[measure]); }, 0) || 1;
    var total = rows.reduce(function (s, r) { return s + r[measure]; }, 0) || 1;
    var named = rows.filter(function (r) { return !(r.pinned || r.folded); }).map(function (r) { return r[measure] / total; });
    var lo = named.length ? Math.min.apply(null, named) : 0, hi = named.length ? Math.max.apply(null, named) : 1;
    var list = document.createElement('ol');
    list.className = 'ob-bars';
    rows.forEach(function (r) {
      var li = document.createElement('li');
      li.className = 'ob-bar' + (r.pinned || r.folded ? ' is-muted' : '');
      li.tabIndex = 0;
      var share = r[measure] / total;
      r.share = share;
      li.setAttribute('aria-label', r.name + ': ' + fmt(r[measure]) + ' ' + MEASURES[measure].label.toLowerCase() +
        ', ' + pct(r[measure], total) + ' of the total shown');
      var name = document.createElement('span'); name.className = 'ob-name'; name.textContent = r.name;
      var track = document.createElement('span'); track.className = 'ob-track';
      var fill = document.createElement('span'); fill.className = 'ob-fill';
      // leave room on the right so the longest bar's number stays inside the card
      fill.style.width = 'calc((100% - 104px) * ' + (r[measure] / max).toFixed(4) + ')';
      fill.style.minWidth = r[measure] > 0 ? '2px' : '0';
      if (!(r.pinned || r.folded)) fill.style.background = heat(hi > lo ? (share - lo) / (hi - lo) : 1);
      var val = document.createElement('span'); val.className = 'ob-val'; val.textContent = fmt(r[measure]) + ' · ' + pct(r[measure], total);
      track.appendChild(fill); track.appendChild(val);
      li.appendChild(name); li.appendChild(track);
      li.addEventListener('pointerenter', function () { showTip(r, li); });
      li.addEventListener('pointerleave', hideTip);
      li.addEventListener('focus', function () { showTip(r, li); });
      li.addEventListener('blur', hideTip);
      list.appendChild(li);
    });
    box.appendChild(list);
  }
  function table(box, rows, caption) {
    box.innerHTML = '';
    var t = document.createElement('table'); t.className = 'ob-table';
    var c = document.createElement('caption'); c.textContent = caption; t.appendChild(c);
    var head = document.createElement('tr');
    var m = state.measure, total = rows.reduce(function (s, r) { return s + r[m]; }, 0);
    ['', 'Outbreaks', 'Illnesses', 'Hospitalizations', 'Deaths', '% of ' + MEASURES[m].label.toLowerCase()].forEach(function (h) {
      var th = document.createElement('th'); th.textContent = h; th.scope = 'col'; head.appendChild(th);
    });
    var thead = document.createElement('thead'); thead.appendChild(head); t.appendChild(thead);
    var tb = document.createElement('tbody');
    rows.forEach(function (r) {
      var tr = document.createElement('tr');
      var th = document.createElement('th'); th.scope = 'row'; th.textContent = r.name; tr.appendChild(th);
      ['outbreaks', 'ill', 'hosp', 'deaths'].forEach(function (k) {
        var td = document.createElement('td'); td.textContent = fmt(r[k]); tr.appendChild(td);
      });
      var tp = document.createElement('td'); tp.textContent = pct(r[m], total); tr.appendChild(tp);
      tb.appendChild(tr);
    });
    t.appendChild(tb);
    box.appendChild(t);
  }

  // ------------------------------------------------------------------ controls + state
  var form = root.querySelector('[data-ob-form]');
  var causeBox = root.querySelector('[data-ob-causes]');
  var foodBox = root.querySelector('[data-ob-foods]');
  var foodNote = root.querySelector('[data-ob-food-note]');
  var scopeEls = root.querySelectorAll('[data-ob-scope]');
  var tableBtn = root.querySelector('[data-ob-table]');
  var state = { state: '', years: '10', measure: 'ill', table: false, maxYear: 0, minYear: 0, seq: 0 };

  function setStat(k, v) { var el = root.querySelector('[data-ob-stat="' + k + '"]'); if (el) el.textContent = v; }
  function range() {
    var to = state.maxYear, from = state.years === 'all' ? state.minYear : to - (+state.years) + 1;
    return { from: Math.max(from, state.minYear), to: to };
  }
  function readUrl() {
    try {
      var sp = new URLSearchParams(location.search);
      if (sp.get('ob_state')) state.state = sp.get('ob_state');
      if (/^(5|10|all)$/.test(sp.get('ob_years') || '')) state.years = sp.get('ob_years');
      if (MEASURES[sp.get('ob_measure')]) state.measure = sp.get('ob_measure');
    } catch (e) { /* ignore */ }
  }
  function writeUrl() {
    try {
      var sp = new URLSearchParams(location.search);
      [['ob_state', state.state, ''], ['ob_years', state.years, '10'], ['ob_measure', state.measure, 'ill']].forEach(function (x) {
        if (x[1] && x[1] !== x[2]) sp.set(x[0], x[1]); else sp.delete(x[0]);
      });
      var qs = sp.toString();
      history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
    } catch (e) { /* ignore */ }
  }

  // 5-year annual average for the chosen state: the latest 5 years in the data, sum / 5. Follows the state,
  // measure and table pickers (not the years picker): tiles plus a germ chart and a food chart.
  function perYear(list, yrs) {
    return list.map(function (x) {
      return { name: x.name, outbreaks: x.outbreaks / yrs, ill: x.ill / yrs, hosp: x.hosp / yrs, deaths: x.deaths / yrs };
    });
  }
  function match(rows, avg) {
    var by = {}, zero = { outbreaks: 0, ill: 0, hosp: 0, deaths: 0 };
    avg.forEach(function (x) { by[x.name] = x; });
    return rows.map(function (r) {
      var o = { name: r.name, outbreaks: 0, ill: 0, hosp: 0, deaths: 0, pinned: r.pinned, folded: r.folded };
      (r.folded || [r]).forEach(function (x) {
        var v = by[x.name] || zero;
        o.outbreaks += v.outbreaks; o.ill += v.ill; o.hosp += v.hosp; o.deaths += v.deaths;
      });
      return o;
    });
  }
  var mainRows = { causes: [], foods: [] };
  function renderAvg(seq) {
    var to = state.maxYear, from = Math.max(to - 4, state.minYear), yrs = to - from + 1;
    var af = { state: state.state, from: from, to: to };
    var scope = (state.state || 'All states') + ', ' + from + '–' + to;
    var lab = root.querySelector('[data-ob-avg-label]');
    if (lab) lab.textContent = 'Average per year, ' + from + '–' + to + (state.state ? ' (' + state.state + ')' : ' (all states)');
    Array.prototype.forEach.call(root.querySelectorAll('[data-ob-avg-scope]'), function (el) { el.textContent = scope; });
    var aCause = root.querySelector('[data-ob-avg-causes]'), aFood = root.querySelector('[data-ob-avg-foods]');
    Promise.all([get(soql({ $select: SUMS, $where: where(af) })), grouped('etiology', af), grouped('ifsac_category', af)]).then(function (res) {
      if (seq !== state.seq) return;
      var a = res[0][0] || {};
      ['outbreaks', 'ill', 'hosp', 'deaths'].forEach(function (k) {
        var el = root.querySelector('[data-ob-avg="' + k + '"]');
        if (el) el.textContent = fmt(n(a[k]) / yrs);
      });
      if (!aCause || !aFood) return;
      var m = state.measure;
      var causes = perYear(fold(res[1], function (x) { return causeOf(x.etiology); }), yrs);
      var foods = perYear(fold(res[2], function (x) { return foodOf(x.ifsac_category); }), yrs);
      // same categories, same order (incl. "All other") as the chart above, so each average sits under its bar
      var cRows = match(mainRows.causes, causes), fRows = match(mainRows.foods, foods);
      if (!n(a.outbreaks) || !cRows.length) {
        aCause.innerHTML = aFood.innerHTML = '';
        var p = document.createElement('p'); p.className = 'ob-empty';
        p.textContent = n(a.outbreaks) ? 'No outbreaks in the chart above to compare.' : 'No foodborne outbreaks were reported for ' + scope + '.';
        aCause.appendChild(p);
      } else if (state.table) {
        table(aCause, cRows, 'Causes of foodborne outbreaks, average per year, ' + scope);
        table(aFood, fRows, 'Foods linked to outbreaks, average per year, ' + scope);
      } else {
        bars(aCause, cRows, m);
        bars(aFood, fRows, m);
      }
    }).catch(function () { /* keep the dashes */ });
  }

  function render() {
    var seq = ++state.seq, r = range();
    var f = { state: state.state, from: r.from, to: r.to };
    root.classList.add('is-loading');
    var label = (state.state || 'All states') + ', ' + (r.from === r.to ? r.from : r.from + '–' + r.to);
    Array.prototype.forEach.call(scopeEls, function (el) { el.textContent = label; });
    return Promise.all([grouped('etiology', f), grouped('ifsac_category', f)]).then(function (res) {
      if (seq !== state.seq) return;
      var causes = fold(res[0], function (x) { return causeOf(x.etiology); });
      var foodsAll = fold(res[1], function (x) { return foodOf(x.ifsac_category) || '__none'; });
      var none = foodsAll.filter(function (x) { return x.name === '__none'; })[0];
      var foods = foodsAll.filter(function (x) { return x.name !== '__none'; });
      var tot = causes.reduce(function (t, x) { t.outbreaks += x.outbreaks; t.ill += x.ill; t.hosp += x.hosp; t.deaths += x.deaths; return t; },
        { outbreaks: 0, ill: 0, hosp: 0, deaths: 0 });
      setStat('outbreaks', fmt(tot.outbreaks)); setStat('ill', fmt(tot.ill)); setStat('hosp', fmt(tot.hosp)); setStat('deaths', fmt(tot.deaths));
      var m = state.measure;
      var cRows = topN(causes, m, ['More than one germ', 'Unknown cause']);
      var fRows = topN(foods, m, []);
      mainRows = { causes: cRows, foods: fRows };
      renderAvg(seq);
      if (!tot.outbreaks) {
        causeBox.innerHTML = foodBox.innerHTML = '';
        var p = document.createElement('p'); p.className = 'ob-empty';
        p.textContent = 'No foodborne outbreaks were reported for ' + label + '.';
        causeBox.appendChild(p);
      } else if (state.table) {
        table(causeBox, cRows, 'Causes of foodborne outbreaks, ' + label);
        table(foodBox, fRows, 'Foods linked to outbreaks, ' + label);
      } else {
        bars(causeBox, cRows, m);
        bars(foodBox, fRows, m);
      }
      if (foodNote) {
        foodNote.textContent = none && none.outbreaks ? fmt(none.outbreaks) + ' of ' + fmt(tot.outbreaks) +
          ' outbreaks had no single food category identified and are not shown here.' : '';
      }
      root.classList.remove('is-loading');
    }).catch(function () {
      if (seq !== state.seq) return;
      root.classList.remove('is-loading');
      causeBox.innerHTML = '<p class="ob-empty">We could not reach the CDC outbreak data just now. Please try again in a minute.</p>';
      foodBox.innerHTML = '';
    });
  }

  function init() {
    readUrl();
    var bounds = get(soql({ $select: 'min(year) as lo, max(year) as hi', $where: "primary_mode='Food'" }));
    var states = get(soql({ $select: 'state, count(*) as n', $where: "primary_mode='Food'", $group: 'state', $order: 'state', $limit: 200 }));
    return Promise.all([bounds, states]).then(function (res) {
      state.minYear = +res[0][0].lo; state.maxYear = +res[0][0].hi;
      var sel = form && form.elements.state;
      if (sel) {
        res[1].forEach(function (s) {
          if (!s.state) return;
          var o = document.createElement('option');
          o.value = s.state;
          o.textContent = s.state === 'Multistate' ? 'Multistate outbreaks' : s.state;
          sel.appendChild(o);
        });
        sel.value = state.state;
        if (sel.value !== state.state) state.state = '';
      }
      if (form) {
        form.elements.years.value = state.years;
        form.elements.measure.value = state.measure;
        Array.prototype.forEach.call(form.elements.years.options, function (o) {
          // short labels so the select fits on a phone; the field label already says "Years"
          var from = o.value === 'all' ? state.minYear : state.maxYear - (+o.value) + 1;
          o.textContent = from + '–' + state.maxYear + (o.value === 'all' ? ' (all)' : '');
        });
      }
      var yr = root.querySelector('[data-ob-latest]');
      if (yr) yr.textContent = state.maxYear;
      return render();
    }).catch(function () {
      causeBox.innerHTML = '<p class="ob-empty">We could not reach the CDC outbreak data just now. Please try again in a minute.</p>';
    });
  }

  if (form) {
    form.addEventListener('change', function () {
      state.state = form.elements.state.value;
      state.years = form.elements.years.value;
      state.measure = form.elements.measure.value;
      writeUrl();
      hideTip();
      render();
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); });
  }
  if (tableBtn) {
    tableBtn.addEventListener('click', function () {
      state.table = !state.table;
      tableBtn.setAttribute('aria-pressed', state.table ? 'true' : 'false');
      tableBtn.textContent = state.table ? 'Show as chart' : 'Show as table';
      hideTip();
      render();
    });
  }
  init();
  window.VGOutbreaks = { causeOf: causeOf, foodOf: foodOf, where: where, soql: soql };
})();
